import { Currency } from './currency';

export interface Company {
  id: number;
  name: string;
  address?: string | null;
  nif?: string | null;
  incomeAccount?: string | null;
  expenseAccount?: string | null;
  phone?: string | null;
  email?: string | null;
  contact?: string | null;
  webSite?: string | null;
  zipCode?: string | null;
  countryId?: number | null;
  country?: {
    id: number;
    name: string;
    code: string;
    taxName: string;
    odooEntityId?: number | null;
  } | null;
  currencyId?: number | null;
  currency?: Currency | null;
  odooEntityId?: number | null;
  logo?: string | null;
  terms?: string | null;
}

export interface UserCompany {
  id: number,
  companyId: number,
  userId: number
}
